<script setup lang="ts">
const props = defineProps({
  sections: Array
})

const sectionsFormated = computed(() => (props.sections ?? []).reduce((r, i) => {

  if (!i.type && (i.orientation === undefined || i.orientation === 'horizontal')) {
    i.orientation = 'horizontal'
    if (i.reverse === undefined) {
      if (!r.length) {
        i.reverse = false
      } else {
        i.reverse = !r.at(-1).reverse
      }
    }
  }

  r.push(i)
  return r
}, []))
</script>

<template>
  <div v-for="(section, index) in sectionsFormated" :key="index">
    <SectionAbout v-if="section.type == 'about'" />
    <UContainer v-else-if="section.type == 'logos'">
      <UPageLogos :title="section.title" v-if="section.type == 'logos'">
        <div v-for="(logo, index) in section.items" :key="index" class="m-auto">
          <NuxtLink v-if="logo.to" :to="logo.to" external target="_blank" rel="nofollow noopener noreferrer"  class="m-auto">
            <NuxtImg :src="logo.src" :alt="logo.alt" class="h-12" />
          </NuxtLink>
          <NuxtImg v-else :src="logo.src" :alt="logo.alt" class="h-12" />
        </div>
      </UPageLogos>
    </UContainer>
    <UContainer v-else-if="section.type == 'cta'" class="my-8">
      <UPageCTA
          :title="section.title"
          :links="section.links"
          :variant="section.variant ? section.variant : 'soft'"
          :ui="section.ui"
      >
        <template #description>
          <MDC :value="section.description" unwrap="p" />
        </template>
      </UPageCTA>
    </UContainer>
    <slot v-else-if="section.id" :name="`${section.id}-section`" :section="section" />
    <UPageSection
        :title="section.type !== 'logos' ? section.title : null"
        :reverse="section.reverse"
        :orientation="section.orientation"
        :features="section.features"
        :links="section.links"
        :ui="section.ui"
        :id="section.anchor"
        v-else
    >
      <template #description>
        <MDC :value="section.description" unwrap="p" :key="index" />
      </template>

      <template v-if="section.type === 'card-features'" #features>
        <UPageCard
            v-for="(item, index) in section.items"
            :key="index"
            v-bind="item"
        >
          <template #description>
            <MDC :value="item.description" unwrap="p" :key="index" />
          </template>
          <img v-if="item.img" :src="item.img.src"/>
        </UPageCard>
      </template>

      <template v-if="section.type == 'testimonials-slider'">
        <UMarquee
            pause-on-hover
            :overlay="true"
            :ui="{ root: '[--gap:calc(var(--spacing)*4)]', content: 'w-auto' }"
        >
          <UPageCard
              v-for="(testimonial, index) in section.items"
              :key="index"
              variant="subtle"
              :description="testimonial.quote"
              :ui="{
          description: 'before:content-[open-quote] after:content-[close-quote]'
        }"
              class="w-64 shrink-0"
          >
            <template #footer>
              <UUser v-bind="testimonial.author" size="xl" />
            </template>
          </UPageCard>
        </UMarquee>
      </template>

      <template v-if="section.type == 'testimonials'">
        <UPageColumns>
          <UPageCard
              v-for="(testimonial, index) in section.items"
              :key="index"
              variant="subtle"
              :description="testimonial.quote"
              :ui="{ description: 'before:content-[open-quote] after:content-[close-quote]' }"
          >
            <template #footer>
              <UUser
                  v-bind="testimonial.author"
                  size="lg"
              />
            </template>
          </UPageCard>
        </UPageColumns>
      </template>

      <template v-if="section.type == 'video'">
        <ScriptYouTubePlayer
            thumbnail-size="maxresdefault"
            ref="video"
            above-the-fold
            :video-id="section.video"
            :placeholder-attrs="{style: {objectFit: 'cover'}}"
            class="max-w-200 m-auto"
        >
          <template #awaitingLoad>
            <div class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[48px] w-[68px]">
              <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00" /><path d="M 45,24 27,14 27,34" fill="#fff" /></svg>
            </div>
          </template>
        </ScriptYouTubePlayer>
      </template>

      <slot :name="`${section.id}-media`"><NuxtImg v-if="section.img" :src="section.img.src ? section.img.src : section.img" :class="section.img.class ? section.img.class : 'w-full'" :alt="section.img.alt ? section.img.alt : null"/></slot>
      <template #bottom>
        <UContainer class="my-20">
          <p class="text-center text-sm font-semibold">{{section.bottom}}</p>
        </UContainer>
      </template>
    </UPageSection>
  </div>
</template>